// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__O35fn","header":"ReportDetails_header__zEMHE","title":"ReportDetails_title__gxdrf","left":"ReportDetails_left__45YNZ"};